import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-beauftragtenprogramm',
  templateUrl: './beauftragtenprogramm.component.html',
  styleUrls: ['./beauftragtenprogramm.component.scss']
})
export class BeauftragtenprogrammComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
